import { render, staticRenderFns } from "./Fab.vue?vue&type=template&id=a4a7ce12&scoped=true&"
import script from "./Fab.vue?vue&type=script&lang=js&"
export * from "./Fab.vue?vue&type=script&lang=js&"
import style0 from "./Fab.vue?vue&type=style&index=0&id=a4a7ce12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a7ce12",
  null
  
)

export default component.exports